<template>
    <participant-ficha-component :ui="'admin'"></participant-ficha-component>
</template>

<script>
import ParticipantFichaComponent from '@/components/Admin-Employee-Participant/ParticipantFichaComponent.vue'

export default {
  components: { ParticipantFichaComponent },
    name: "ParticipantFicha",
    data: () => ({})
}
</script>